import React, {useState, useEffect} from 'react';
import {Fab, Stagger} from 'native-base';
import {IStaggerStyleProps} from 'native-base/lib/typescript/components/composites/Transitions/Stagger';
import {ISupportedTransitions} from 'native-base/lib/typescript/components/composites/Transitions/types';
import {
  CallCenterOffIcon,
  CallCenterOnIcon,
  CallPhoneIcon,
  WhatsappIcon,
} from './../icons';

interface Props {
  localBalance?: string;
  summary?: string;
  label?: string;
  whatsappActive: boolean;
  onCallPhone?: () => void;
  onCallWhatsapp?: () => void;
}

const POST_Y_INIT = 175;

const CallCenterItem = function (props: Props) {
  const {
    onCallWhatsapp: handleContactWhatsapp,
    onCallPhone: handleCallPhone,
    whatsappActive,
  } = props;
  const [showButtons, setShowButtons] = useState(false);
  const animate: IStaggerStyleProps = {
    translateY: 0,
    scale: 1,
    opacity: 1,
    transition: {
      type: 'spring',
      mass: 0.8,
      stagger: {
        offset: 30,
        reverse: true,
      },
    },
  };
  const exit: IStaggerStyleProps = {
    translateY: 34,
    scale: 0.5,
    opacity: 0,
    transition: {
      duration: 100,
      stagger: {
        offset: 30,
        reverse: true,
      },
    },
  };

  const initial: ISupportedTransitions = {
    opacity: 0,
    scale: 0,
    translateY: 34,
  };

  const timer = React.useRef(null as unknown | number);

  useEffect(() => {
    if (showButtons) {
      timer.current = setTimeout(function () {
        setShowButtons(false);
      }, 5000);
    }
  }, [showButtons]);

  const handlePressCallCenter = () => {
    if (showButtons) {
      clearTimeout(timer.current as number);
      setShowButtons(false);
    } else {
      setShowButtons(true);
    }
  };

  return (
    <>
      <Fab
        renderInPortal={false}
        shadow={2}
        right={4}
        bottom={4}
        icon={showButtons ? <CallCenterOnIcon /> : <CallCenterOffIcon />}
        onPress={handlePressCallCenter}
        boxSize="70"
      />
      {showButtons && (
        <>
          <Stagger
            visible={true}
            initial={initial}
            animate={animate}
            exit={exit}>
            <Fab
              renderInPortal={false}
              shadow={2}
              right={4}
              bottom={POST_Y_INIT}
              icon={<CallPhoneIcon />}
              onPress={handleCallPhone}
              boxSize="70"
            />
          </Stagger>
          {whatsappActive && (
            <Stagger
              visible={true}
              initial={initial}
              animate={animate}
              exit={exit}>
              <Fab
                renderInPortal={false}
                shadow={2}
                right={4}
                bottom={POST_Y_INIT + 80}
                icon={<WhatsappIcon />}
                onPress={handleContactWhatsapp}
                boxSize="70"
              />
            </Stagger>
          )}
        </>
      )}
    </>
  );
};

export default CallCenterItem;
